import { FormDataModel as Model } from './Model'


export const MODULE_NAME = 'form_data_routes'
export const MODULE_NAME_CACHES = 'form-data-cache'

export const FORM_DATA_ROUTES = {
  LAYOUT: MODULE_NAME,
  LIST: `${MODULE_NAME}.list`,
  VIEW: `${MODULE_NAME}.view`,
  EDIT: `${MODULE_NAME}.edit`,
  CREATE: `${MODULE_NAME}.create`,
} as const

export const MENU = {
  id: FORM_DATA_ROUTES.LAYOUT,
  route: { name: FORM_DATA_ROUTES.LAYOUT },
  label: Model.page_title.list,
  icon: 'mdi-form-select',
} as const
